var _path, _circle, _path2, _circle2, _path3, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7357 17.9892C17.7357 17.5516 17.7357 17.3327 17.6637 17.1601C17.5678 16.93 17.3839 16.7471 17.1524 16.6518C16.9788 16.5803 16.7587 16.5803 16.3184 16.5803H15.6098C15.1696 16.5803 14.9495 16.5803 14.7759 16.6518C14.5444 16.7471 14.3604 16.93 14.2645 17.1601C14.1926 17.3327 14.1926 17.5516 14.1926 17.9892M16.9089 14.7017C16.9089 15.2205 16.4859 15.641 15.9641 15.641C15.4423 15.641 15.0193 15.2205 15.0193 14.7017C15.0193 14.183 15.4423 13.7625 15.9641 13.7625C16.4859 13.7625 16.9089 14.183 16.9089 14.7017Z",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9641,
    cy: 15.0591,
    r: 3.46411,
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5659 8.80791C12.5659 8.17401 12.5659 7.85706 12.4617 7.60704C12.3228 7.27369 12.0564 7.00884 11.7211 6.87076C11.4696 6.7672 11.1508 6.7672 10.5131 6.7672H9.48679C8.84916 6.7672 8.53035 6.7672 8.27886 6.87076C7.94355 7.00884 7.67714 7.27369 7.53825 7.60704C7.43408 7.85706 7.43408 8.17401 7.43408 8.80791M11.3684 4.04626C11.3684 4.79763 10.7558 5.40673 9.99997 5.40673C9.24418 5.40673 8.6315 4.79763 8.6315 4.04626C8.6315 3.29489 9.24418 2.68579 9.99997 2.68579C10.7558 2.68579 11.3684 3.29489 11.3684 4.04626Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.96411,
    cy: 5.05908,
    r: 4.55908,
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73565 17.9892C5.73565 17.5516 5.73565 17.3327 5.66373 17.1601C5.56784 16.93 5.38391 16.7471 5.15241 16.6518C4.97878 16.5803 4.75867 16.5803 4.31844 16.5803H3.60984C3.16961 16.5803 2.9495 16.5803 2.77587 16.6518C2.54437 16.7471 2.36044 16.93 2.26455 17.1601C2.19263 17.3327 2.19263 17.5516 2.19263 17.9892M4.90895 14.7017C4.90895 15.2205 4.48594 15.641 3.96414 15.641C3.44234 15.641 3.01933 15.2205 3.01933 14.7017C3.01933 14.183 3.44234 13.7625 3.96414 13.7625C4.48594 13.7625 4.90895 14.183 4.90895 14.7017Z",
    stroke: "currentColor",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.96411,
    cy: 15.0591,
    r: 3.46411,
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 9.56377V11.5949M10.0001 11.5949L7.1228 13.2561M10.0001 11.5949L12.8772 13.2561",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamManagementIcon);
export default __webpack_public_path__ + "static/media/team-management-icon.c07fdeda645ac9fcbf129d5470fefa36.svg";
export { ForwardRef as ReactComponent };